import { invoiceCurrency, paymentCurrency, formatInvoiceCurrencyAmount } from "helpers/invoiceCurrency";
import React from "react";
import PropTypes from "prop-types";

const amount = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const result = typeof value === "object" ? Number(value.amount_minor) / 100 : Number(value);
  return Number.isFinite(result) ? result : null;
};

export default function InvoiceDiscountBreakdown({ invoice = {} }) {
  const code = invoice.discount_code;
  const discount = amount(invoice.code_discount);
  const subtotal = amount(invoice.subtotal ?? invoice.cart_total ?? invoice.cart_sum_cost);
  if (!code || discount === null || discount <= 0 || subtotal === null) return null;
  const currency = paymentCurrency({amount:invoice.code_discount}, invoiceCurrency(invoice));
  const format = (value) => formatInvoiceCurrencyAmount(value, currency);
  return <li className="list-group-item">
    <div className="d-flex justify-content-between"><span>Subtotal</span><span>{format(subtotal)}</span></div>
    <div className="d-flex justify-content-between"><span>Discount ({code})</span><span>-{format(discount)}</span></div>
  </li>;
}
InvoiceDiscountBreakdown.propTypes = { invoice: PropTypes.object, fallbackCurrency: PropTypes.string };
